export default {"src":"/_next/static/media/kmd.668611ea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};